import { useCallback, useEffect, useState } from "react";
import { selectionHistoryApi } from "../../Api/selectionHistory";

export function useDefaultParticipantsSelectionHistories(userId: number) {
  const [defaultParticipantsHistory, setDefaultParticipantsHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId || userId === 0 ) return; 
  }, [userId]);

  // GET
  const fetchDefaultParticipantsHistory = useCallback(() => {
    if (!userId) return;
    setLoading(true);
    selectionHistoryApi.getDefaultParticipantsSelectionHistories(userId)
      .then(res => setDefaultParticipantsHistory(res.data.data))
      .finally(() => setLoading(false));
  }, [userId]);

  useEffect(() => { fetchDefaultParticipantsHistory(); }, [fetchDefaultParticipantsHistory]);

  // POST
  const storeDefaultParticipantsSelection = useCallback(async (body: any) => {
    await selectionHistoryApi.storeDefaultParticipantsSelection(body);
    fetchDefaultParticipantsHistory();
  }, [fetchDefaultParticipantsHistory]);

  return { defaultParticipantsHistory, loading, storeDefaultParticipantsSelection, fetchDefaultParticipantsHistory };
}
